import { render, staticRenderFns } from "./RoomsLive.vue?vue&type=template&id=3055423a&scoped=true"
import script from "./RoomsLive.vue?vue&type=script&lang=js"
export * from "./RoomsLive.vue?vue&type=script&lang=js"
import style0 from "./RoomsLive.vue?vue&type=style&index=0&id=3055423a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055423a",
  null
  
)

export default component.exports